/**
 * Card — OutCRM's surface container: white, radius 8, hairline ring (--ring-card).
 * The "ring, not shadow" language used across the product.
 *
 * Ported from the skill's components/data-display/Card.jsx as the SURFACE ONLY
 * (spec S3 #5, contract narrowed): the DS contract (title / actions / footer /
 * padding / interactive) cannot express a clickable header plus a lazily mounted body,
 * which is what the Monitoring card is, so the header/body composition stays at screen
 * level and this component takes `children` only. `interactive` is unused by design —
 * the header, not the card, is the click target.
 */
export function Card ({ children, className, ...rest }) {
  return (
    <div className={['oc-card', className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </div>
  );
}
